export { OnTypeFormattingProvider } from './OnTypeFormattingProvider';
